import type { SearchPreferences as DirectSearchPreferences } from "@searchui-searchforms/shared/user-preferences";
import type {
    UserPreferences as LegacyUserPreferences,
    SaveUserPreferencesBody,
} from "@searchui-searchforms/shared/user-preferences";

export type {
    LegacyUserPreferences as UserPreferences,
    SaveUserPreferencesBody,
    DirectSearchPreferences as SearchPreferences,
};

export type SearchPreferencesRead = LegacyUserPreferences | DirectSearchPreferences;

export const isDirectSearchPreferences = (
    preferences: SearchPreferencesRead | null | undefined,
): preferences is DirectSearchPreferences => preferences != null && "types" in preferences;

export type SaveUserPreferencesPayload = Omit<
    SaveUserPreferencesBody,
    "givenNameExactness" | "surnameExactness" | "matchAllTermsExactly"
> & {
    givenNameExactness?: DirectSearchPreferences["givenNameExactness"];
    surnameExactness?: DirectSearchPreferences["surnameExactness"];
    /** Legacy numeric focus retained only until the rollout branch is removed. */
    legacyCollectionFocus?: string;
    matchAllTermsExactly?: boolean;
};
